import React from 'react';
import {Route, Switch, withRouter} from 'react-router';


import {userConsts} from '../constants/users';
import {EmptyPage} from '../views/empty';

import Loadable from 'react-loadable'
//import {Header} from '../components/header';
import {Header} from '../components/forumFullPage/forumHeader';
import styles from '../views/championships/styles.scss';
import {isMobile} from 'react-device-detect';
import {getMobileWidth} from '../utils/ui';


const Loading = () => (
    <div className={styles.fullPageBack}>
        <div className={styles.fullPage} style={isMobile ? {minHeight: getMobileWidth() + 'px'} : {}}>
            <Header/>
        </div>
    </div>
);
const LoadingMain = () => (
    <div className={styles.fullPageBack} style={{background: 'none'}}>
        <div className={styles.fullPage} style={isMobile ? {minHeight: getMobileWidth() + 'px'} : {}}>
            <Header/>
        </div>
    </div>
);

const MainPage = Loadable({
    loader: () => import('../views/main/index.jsx'),
    loading: LoadingMain,
});

const LoginPage = Loadable({
    loader: () => import('../views/login/index.jsx'),
    loading: Loading,
});

const ResetPasswordPage = Loadable({
    loader: () => import('../views/resetPassword/index.jsx'),
    loading: Loading,
});

const ClientChampEditor = Loadable({
    loader: () => import('../views/clientChampEditor/index.jsx'),
    loading: Loading,
});

const ChampionshipsPage = Loadable({
    loader: () => import('../views/championships/index.jsx'),
    loading: Loading,
});

const RatingPage = Loadable({
    loader: () => import('../views/rating/index.jsx'),
    loading: Loading,
});

const UserPage = Loadable({
    loader: () => import('../views/user/index.jsx'),
    loading: Loading,
});

const ChampionshipPage = Loadable({
    loader: () => import('../views/championship/index.jsx'),
    loading: Loading,
});

const AdminPage = Loadable({
    loader: () => import('../views/admin/index.jsx'),
    loading: Loading,
});

const SetNewLoginPage = Loadable({
    loader: () => import('../views/newLogin/index.jsx'),
    loading: Loading,
});


const SetUserLoginPage = Loadable({
    loader: () => import('../views/userLogin/index.jsx'),
    loading: Loading,
});

const RegistrationPage = Loadable({
    loader: () => import('../views/registration/index.jsx'),
    loading: Loading,
});

const AboutPage = Loadable({
    loader: () => import('../views/about/index.jsx'),
    loading: Loading,
});

const VacancyPage = Loadable({
    loader: () => import('../views/vacancy/index.jsx'),
    loading: Loading,
});

const ForumPage = Loadable({
    loader: () => import('../views/forum/index.jsx'),
    loading: Loading,
});

/*
const ArticlePage = Loadable({
    loader: () => import('../views/article/index.jsx'),
    loading: Loading,
});
*/


const MainRouter = () => (
    <Switch>
        {/*<Route exact path='/' component={MainPage}/>*/}
        <Route exact path='/' component={ForumPage}/>
        <Route path='/login' component={LoginPage}/>
        <Route path='/password' component={ResetPasswordPage}/>
        <Route path='/username' component={SetUserLoginPage}/>
        <Route path='/registration' component={RegistrationPage}/>
        <Route path='/about' component={AboutPage}/>
        <Route path='/championships/:tabname' component={ChampionshipsPage}/>
        <Route path='/championships' component={ChampionshipsPage}/>
        <Route path='/vacancy' component={VacancyPage}/>
        <Route path='/rating/:tabname' component={RatingPage}/>
        <Route path='/rating' component={RatingPage}/>
        <Route path='/user/:login' component={UserPage}/>
        <Route path='/championship/:champname/edit' component={ClientChampEditor}/>
        <Route path='/championship/:champname/:tabname/:subtab' component={ChampionshipPage}/>
        <Route path='/championship/:champname/:tabname' component={ChampionshipPage}/>
        <Route path='/championship/:champname' component={ChampionshipPage}/>
        <Route path='/homeinvienna_boosterspro_eto_vse_luna'
               component={JSON.parse(localStorage.getItem(process.env.LOCAL_STORAGE)).user && JSON.parse(localStorage.getItem(process.env.LOCAL_STORAGE)).user.statusLoad === userConsts.LOADING_STATUS.LOADED && JSON.parse(localStorage.getItem(process.env.LOCAL_STORAGE)).user.role === 'admin' ? AdminPage : EmptyPage}/>
        <Route path='/changelogin' component={SetNewLoginPage}/>
        {/*<Route path='/forum/article/:tabname' component={ArticlePage}/>*/}
        {/*<Route path='/forum/article' component={ArticlePage}/>*/}
        <Route path='/forum/:tabname/:subtab' component={ForumPage}/>
        <Route path='/forum/:tabname' component={ForumPage}/>
        <Route path='/forum' component={ForumPage}/>
    </Switch>
);


export default withRouter(MainRouter);



// WEBPACK FOOTER //
// src/routers/index.jsx